module.exports = __webpack_public_path__ + "static/bg-office-usa-8003573c3bff55b09cf79388f830cc0e.png";